/* Native Shopify forms are handled by the existing OrienX cart drawer. */

(()=>{'use strict';

function init(root=document){

 root.querySelectorAll('[data-rx-hero]').forEach(h=>{if(h.dataset.ready)return;h.dataset.ready='1';const slides=[...h.querySelectorAll('[data-rx-hero-slide]')],dots=[...h.querySelectorAll('[data-rx-hero-dot]')];let index=0;function show(n){index=n;slides.forEach((s,i)=>s.hidden=i!==n);dots.forEach((b,i)=>b.setAttribute('aria-current',String(i===n)))}dots.forEach((b,i)=>b.addEventListener('click',()=>show(i)));show(0);if(!matchMedia('(prefers-reduced-motion:reduce)').matches)setInterval(()=>{if(!document.hidden&&!h.matches(':hover')&&!h.contains(document.activeElement))show((index+1)%slides.length)},7000)});

 root.querySelectorAll('[data-rx-gallery]').forEach(g=>{

  if(g.dataset.ready)return;g.dataset.ready='1';

  const images=[...g.querySelectorAll('[data-rx-slide]')],thumbs=[...g.querySelectorAll('[data-rx-thumb]')];

  const counter=g.querySelector('[data-rx-counter]'),track=g.querySelector('[data-rx-gallery-track]'),viewport=g.querySelector('[data-rx-gallery-viewport]');

  const rail=g.querySelector('[data-rx-thumbs-rail]'),thumbPrev=g.querySelector('[data-rx-thumbs-prev]'),thumbNext=g.querySelector('[data-rx-thumbs-next]'),caption=g.querySelector('[data-rx-gallery-caption]');

  function railControls(){if(!rail)return;if(thumbPrev)thumbPrev.disabled=rail.scrollLeft<=1;if(thumbNext)thumbNext.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-1}

  function revealThumb(button){

   if(!rail||!button)return;

   const frame=rail.getBoundingClientRect(),item=button.getBoundingClientRect();

   let left=rail.scrollLeft;

   if(item.left<frame.left)left-=frame.left-item.left;

   else if(item.right>frame.right)left+=item.right-frame.right;

   else return;

   rail.scrollTo({left:Math.max(0,left),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});

  }

  if(rail){

   rail.addEventListener('scroll',railControls,{passive:true});

   rail.addEventListener('focusin',event=>revealThumb(event.target.closest('[data-rx-thumb]')));

   const scrollRail=direction=>rail.scrollBy({left:direction*Math.max(60,rail.clientWidth-72),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});

   thumbPrev?.addEventListener('click',()=>scrollRail(-1));thumbNext?.addEventListener('click',()=>scrollRail(1));

   if('ResizeObserver' in window){const observer=new ResizeObserver(()=>{if(!rail.isConnected){observer.disconnect();return}railControls()});observer.observe(rail)}

   requestAnimationFrame(railControls);

  }

  if(!images.length)return;

  let index=0,busy=false,queued=null,timer;

  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(track&&images.length>1){

   for(const [original,first] of [[images[images.length-1],true],[images[0],false]]){

    const clone=original.cloneNode(true);clone.removeAttribute('data-rx-slide');clone.removeAttribute('id');clone.hidden=false;clone.alt='';clone.loading='eager';clone.setAttribute('aria-hidden','true');clone.dataset.rxClone='';

    if(first)track.prepend(clone);else track.append(clone);

   }

  }

  const offset=track&&images.length>1?1:0;

  function position(n,instant=false){if(!track)return;if(instant)track.style.transition='none';track.style.transform=`translate3d(${-100*(n+offset)}%,0,0)`;if(instant){void track.offsetWidth;track.style.transition=''}}

  function mark(){

   images.forEach((image,i)=>{image.hidden=track?false:i!==index;image.setAttribute('aria-hidden',String(i!==index));if(i===index)image.loading='eager'});

   thumbs.forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));

   revealThumb(thumbs[index]);railControls();

   if(counter)counter.textContent=`${index+1} / ${images.length}`;

   if(caption){caption.textContent=images[index].dataset.rxCaption||'';caption.hidden=!caption.textContent}

  }

  function settle(){if(!busy)return;clearTimeout(timer);busy=false;position(index,true);g.classList.remove('is-gallery-moving');if(queued){const next=queued;queued=null;show(next.n,next.direction)}}

  function show(n,direction=0){

   const next=((n%images.length)+images.length)%images.length;

   if(busy){queued={n:next,direction};return}

   if(next===index)return;

   const old=index;index=next;if(track&&!reduced())g.classList.add('is-gallery-moving');mark();

   if(!track)return;

   let physical=next;

   if(offset&&old===images.length-1&&next===0&&direction===1)physical=images.length;

   if(offset&&old===0&&next===images.length-1&&direction===-1)physical=-1;

   if(reduced()){position(next,true);return}

   busy=true;position(physical);timer=setTimeout(settle,450);

  }

  track?.addEventListener('transitionend',event=>{if(event.target===track&&event.propertyName==='transform')settle()});

  thumbs.forEach((button,i)=>button.addEventListener('click',()=>show(i)));

  g.querySelector('[data-rx-prev]')?.addEventListener('click',()=>show((queued?.n??index)-1,-1));

  g.querySelector('[data-rx-next]')?.addEventListener('click',()=>show((queued?.n??index)+1,1));

  viewport?.addEventListener('keydown',event=>{if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();const direction=event.key==='ArrowRight'?1:-1;show((queued?.n??index)+direction,direction)});

  let start=null;

  viewport?.addEventListener('pointerdown',event=>{if(event.pointerType==='mouse'&&event.button!==0)return;start={x:event.clientX,y:event.clientY}});

  viewport?.addEventListener('pointerup',event=>{if(!start)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){const direction=dx<0?1:-1;show(index+direction,direction)}});

  viewport?.addEventListener('pointercancel',()=>start=null);

  viewport?.addEventListener('dragstart',event=>event.preventDefault());

  mark();position(index,true);g.classList.add('is-gallery-ready');

 });

 root.querySelectorAll('[data-rx-tabs]').forEach(t=>{

  if(t.dataset.ready)return;t.dataset.ready='1';

  const buttons=[...t.querySelectorAll('[role=tab]')],panels=[...t.parentElement.querySelectorAll('[role=tabpanel]')];

  const viewport=t.parentElement.querySelector('[data-rx-panel-viewport]'),track=t.parentElement.querySelector('[data-rx-panel-track]');

  let index=0;

  function height(){if(viewport&&panels[index])viewport.style.height=`${panels[index].offsetHeight}px`}

  function activate(next,focus=false){

   index=next;

   buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1});

   panels.forEach((panel,i)=>{panel.hidden=track?false:i!==index;panel.setAttribute('aria-hidden',String(i!==index));panel.inert=i!==index});

   if(track){track.style.transform=`translate3d(${-100*index}%,0,0)`;height()}

   if(focus)buttons[index].focus();

   const button=buttons[index],left=button.offsetLeft-t.offsetLeft;

   if(left<t.scrollLeft||left+button.offsetWidth>t.scrollLeft+t.clientWidth)t.scrollTo({left:Math.max(0,left-12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});

  }

  buttons.forEach((button,i)=>{

   button.addEventListener('click',()=>activate(i));

   button.addEventListener('keydown',event=>{let n;if(event.key==='ArrowRight')n=(i+1)%buttons.length;if(event.key==='ArrowLeft')n=(i-1+buttons.length)%buttons.length;if(event.key==='Home')n=0;if(event.key==='End')n=buttons.length-1;if(n!==undefined){event.preventDefault();activate(n,true)}});

  });

  activate(0);

  if(track&&viewport){

   viewport.classList.add('is-panels-ready');

   if('ResizeObserver' in window){const observer=new ResizeObserver(()=>{if(!viewport.isConnected){observer.disconnect();return}height()});panels.forEach(panel=>observer.observe(panel))}

   if(document.fonts?.ready)document.fonts.ready.then(height);

  }

 });

 root.querySelectorAll('[data-rx-qty]').forEach(q=>{if(q.dataset.ready)return;q.dataset.ready='1';const input=q.querySelector('input');q.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{const min=(input.hasAttribute("min")?Number(input.min):1),max=input.max?Number(input.max):9999,step=Number(input.step)||1;input.value=Math.min(max,Math.max(min,(Number(input.value)||min)+Number(b.dataset.step)*step));input.dispatchEvent(new Event('change',{bubbles:true}))}));input.addEventListener('change',()=>{input.value=Math.max((input.hasAttribute("min")?Number(input.min):1),Number(input.value)||1)})});

 root.querySelectorAll('[data-rx-scroll]').forEach(b=>{if(b.dataset.ready)return;b.dataset.ready='1';b.addEventListener('click',()=>{const strip=document.getElementById(b.dataset.rxScroll);if(strip)strip.scrollBy({left:strip.clientWidth*.8*Number(b.dataset.direction),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})})});

 root.querySelectorAll('[data-rx-sort]').forEach(s=>{if(s.dataset.ready)return;s.dataset.ready='1';s.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('sort_by',s.value);location.assign(url.href)})});

}document.addEventListener('DOMContentLoaded',()=>init());document.addEventListener('shopify:section:load',e=>init(e.target));})();



(()=>{'use strict';

function initMudCarousel(root=document){

 root.querySelectorAll('[data-rx-mud-carousel]').forEach(hero=>{

  if(hero.dataset.carouselReady)return;

  hero.dataset.carouselReady='1';

  const slides=[...hero.querySelectorAll('[data-rx-mud-slide]')];

  const dots=[...hero.querySelectorAll('[data-rx-mud-dot]')];

  if(slides.length!==3||dots.length!==3)return;

  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let index=0,timer,gesture=null;

  function show(next){

   index=(next+slides.length)%slides.length;

   slides.forEach((slide,i)=>{

    const active=i===index;

    slide.classList.toggle('is-active',active);

    slide.setAttribute('aria-hidden',String(!active));

    if(active){const image=slide.querySelector('img');if(image)image.loading='eager'}

   });

   // Horizontal gestures change slides; native vertical scrolling and pinch zoom remain available.
  hero.addEventListener('pointerdown',event=>{
   if(event.pointerType!=='touch'&&event.pointerType!=='pen')return;
   if(!event.isPrimary){gesture=null;start();return}
   if(event.target.closest('button,a,input,select,textarea,[role="button"]'))return;
   gesture={id:event.pointerId,x:event.clientX,y:event.clientY,axis:null};
   window.clearInterval(timer);
  },{passive:true});

  hero.addEventListener('pointermove',event=>{
   if(!gesture||event.pointerId!==gesture.id)return;
   const dx=Math.abs(event.clientX-gesture.x),dy=Math.abs(event.clientY-gesture.y);
   if(!gesture.axis&&Math.max(dx,dy)>10)gesture.axis=dx>dy?'x':'y';
  },{passive:true});

  hero.addEventListener('pointerup',event=>{
   if(!gesture||event.pointerId!==gesture.id)return;
   const last=gesture;
   gesture=null;
   const dx=event.clientX-last.x,dy=event.clientY-last.y;
   const threshold=Math.max(40,Math.min(72,hero.clientWidth*.1));
   if(last.axis!=='y'&&Math.abs(dx)>=threshold&&Math.abs(dx)>Math.abs(dy)*1.25)show(index+(dx<0?1:-1));
   start();
  },{passive:true});

  hero.addEventListener('pointercancel',()=>{
   if(!gesture)return;
   gesture=null;
   start();
  },{passive:true});

  dots.forEach((dot,i)=>{dot.setAttribute('aria-current',String(i===index));dot.setAttribute('aria-pressed',String(i===index))});

  }

  function start(){

   window.clearInterval(timer);

   if(reduced||gesture)return;

   timer=window.setInterval(()=>{

    if(!hero.isConnected){window.clearInterval(timer);return}

    if(!document.hidden&&!hero.matches(':hover')&&!hero.matches(':focus-within'))show(index+1);

   },7000);

  }

  dots.forEach((dot,i)=>{

   dot.addEventListener('click',()=>{show(i);start()});

   dot.addEventListener('keydown',event=>{

    let next;

    if(event.key==='ArrowRight')next=(i+1)%dots.length;

    if(event.key==='ArrowLeft')next=(i-1+dots.length)%dots.length;

    if(event.key==='Home')next=0;

    if(event.key==='End')next=dots.length-1;

    if(next===undefined)return;

    event.preventDefault();dots[next].focus();show(next);start();

   });

  });

  show(0);start();

  // Keep inactive slides lazy until show() selects them.

 });

}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initMudCarousel());else initMudCarousel();

document.addEventListener('shopify:section:load',event=>initMudCarousel(event.target));

})();



/* Scroll progress changes only the image stage; the page keeps its native flow. */

(() => {

  'use strict';

  const heroes = new Map();

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let frame = 0;

  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(() => schedule()) : null;



  function update() {

    frame = 0;

    const changes = [];

    for (const [hero, state] of heroes) {

      if (!hero.isConnected) {

        resizeObserver?.unobserve(hero);

        heroes.delete(hero);

        continue;

      }

      const rect = hero.getBoundingClientRect();

      const distance = Math.max(0, Math.min(rect.height, -rect.top));

      const progress = reducedMotion.matches || !rect.height ? 0 : distance / rect.height;

      if (state.progress === progress && state.height === rect.height) continue;

      changes.push({ hero, state, height: rect.height, progress });

    }

    for (const { hero, state, height, progress } of changes) {

      hero.style.setProperty('--rx-hero-shift', `${(height * progress * 0.25).toFixed(2)}px`);

      hero.style.setProperty('--rx-hero-blur', `${(progress * 2).toFixed(3)}px`);

      hero.classList.toggle('is-drawer-scrolling', progress > 0 && progress < 1);

      state.progress = progress;

      state.height = height;

    }

  }

  function schedule() {

    if (heroes.size && !frame) frame = window.requestAnimationFrame(update);

  }

  function init(root = document) {

    const matches = [...root.querySelectorAll('[data-rx-hero-drawer]')];

    if (root.matches?.('[data-rx-hero-drawer]')) matches.unshift(root);

    for (const hero of matches) {

      if (heroes.has(hero) || !hero.querySelector('[data-rx-hero-stage]')) continue;

      heroes.set(hero, { progress: null, height: null });

      resizeObserver?.observe(hero);

    }

    schedule();

  }

  window.addEventListener('scroll', schedule, { passive: true });

  window.addEventListener('resize', schedule, { passive: true });

  window.addEventListener('pageshow', schedule);

  reducedMotion.addEventListener('change', schedule);

  document.addEventListener('shopify:section:load', event => init(event.target));

  document.addEventListener('shopify:section:unload', event => {

    for (const hero of heroes.keys()) {

      if (event.target === hero || event.target.contains(hero)) {

        resizeObserver?.unobserve(hero);

        heroes.delete(hero);

      }

    }

    if (!heroes.size && frame) {

      window.cancelAnimationFrame(frame);

      frame = 0;

    }

  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });

  else init();

})();